import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = 'longDate', language: string = this.translateService.currentLang): any {
    console.log(value);
    console.log(pattern);
    console.log(language);

    if (!value) { return ''; }
    const datePipe: DatePipe = new DatePipe(language);
    return datePipe.transform(value, pattern);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/pipe/localized-date.pipe.ts